enum ErrorCode {
  FORBIDDEN_ERROR = 403
}

export default ErrorCode
